import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ScrollService } from '../../../services/scroll-service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { NgOptimizedImage, UpperCasePipe } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { SearchStoreService } from '../../../../modules/frontpage/stores/search-store.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    UpperCasePipe,
    FlexLayoutModule,
    TranslateModule,
    NgOptimizedImage,
  ],
})
export class HeaderComponent {
  constructor(private scrollService: ScrollService, private searchStore: SearchStoreService) {}
  version = environment.appVersion;

  onLogoClick() {
    this.scrollService.markLogoClick();
    SearchStoreService.isCurrentShowsChecked = true;
  }
}
